module.exports = __webpack_public_path__ + "img/COCOCRUSH_BRACELET_STACKING.865eb31d.jpg";